import { render } from "./SelecionarGrupoDRE.vue?vue&type=template&id=8b19badc&scoped=true&ts=true"
import script from "./SelecionarGrupoDRE.vue?vue&type=script&lang=ts"
export * from "./SelecionarGrupoDRE.vue?vue&type=script&lang=ts"

import "./SelecionarGrupoDRE.vue?vue&type=style&index=0&id=8b19badc&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b19badc"]])

export default __exports__